import { createSlice } from "@reduxjs/toolkit";
import { resetAll } from "./baseSlice";

const initialState = {
  departments: [],
  designations: [],
  managers: [],
  learningPrograms: [],
  roles: [],
};

const metaSlice = createSlice({
  name: "meta",
  initialState,
  extraReducers: (builder) => builder.addCase(resetAll, () => initialState),
  reducers: {
    departmentRequest: (state, action) => {},
    departmentSuccess: (state, action) => {
      state.departments = action.payload.response;
    },
    departmentFail: (state, action) => {
      state.departments = [];
    },
    designationRequest: (state, action) => {},
    designationSuccess: (state, action) => {
      state.designations = action.payload.response;
    },
    designationFail: (state, action) => {
      state.designations = [];
    },
    managerRequest: (state, action) => {},
    managerSuccess: (state, action) => {
      state.managers = action.payload.response;
    },
    managerFail: (state, action) => {
      state.departments = [];
    },
    learningProgramRequest: (state, action) => {},
    learningProgramSuccess: (state, action) => {
      state.learningPrograms = action.payload.response;
    },
    learningProgramFail: (state, action) => {
      state.learningPrograms = [];
    },
    rolesRequest: (state, action) => {},
    rolesSuccess: (state, action) => {
      state.roles = action.payload.response;
    },
    rolesFail: (state, action) => {
      state.roles = [];
    },
  },
});

export const {
  departmentFail,
  departmentRequest,
  departmentSuccess,
  designationFail,
  designationRequest,
  designationSuccess,
  managerFail,
  managerRequest,
  managerSuccess,
  learningProgramFail,
  learningProgramRequest,
  learningProgramSuccess,
  rolesFail,
  rolesRequest,
  rolesSuccess,
} = metaSlice.actions;
export default metaSlice.reducer;
